/* eslint-disable import/prefer-default-export */
export const defaultMonthCountToDivide = 3;